// extracted by mini-css-extract-plugin
export default {"container":"Step2_container__i1Y4f","container-timer":"Step2_container-timer__Lior2"};